import { cloudflareCaptchaSiteKey } from '@/utils/common/env.constants';
import Turnstile from './index';
import { CAPTCHA_WIDGET_IDS, type CaptchaWidgetId } from './constants';

interface CaptchaWidgetProps {
  onVerify: (token: string) => void;
  widgetId?: CaptchaWidgetId | string;
}

const CaptchaWidget = ({ onVerify, widgetId = CAPTCHA_WIDGET_IDS.DEFAULT }: CaptchaWidgetProps) => {
  return (
    <Turnstile
      id={widgetId}
      sitekey={cloudflareCaptchaSiteKey}
      onVerify={(token) => {
        if ((window as any)?.JSBridge?.postCaptchaToken) {
          (window as any)?.JSBridge?.postCaptchaToken(token);
        } else if ((window as any)?.Android?.postCaptchaToken) {
          (window as any).Android.postCaptchaToken(token);
        } else if ((window as any)?.ReactNativeWebView?.postCaptchaToken) {
          (window as any).ReactNativeWebView.postCaptchaToken(token);
        }
        onVerify(token);
      }}
    />
  );
};

export default CaptchaWidget;
